module.exports = __webpack_public_path__ + "media/images/photo-frame-alt-8a14758385a44669ece685b4d0a939db.png";